import { Link } from 'react-router-dom';
import ArrowIcon from '../../../../../assets/images/catalogue/arrowIcon';
import { IlogisticServiceDetails } from '../../../../../types/services';
import { IlogisticServiceDetailsTab } from './LogisticServiceDetailsTabs/LogisticServiceDetailsTabs';
import LogisticServiceHeaderInformationSection from './LogisticServiceHeaderInformationSection/LogisticServiceHeaderInformationSection';
import { ILogisticServiceHistory } from '../../../../../types/suscription/history.types';
import useOnlyDevelopers from 'state/setOnlyDevelopers';

import './LogisticServiceDetailsHeader.scss';

const LogisticServiceDetailsHeader = ({
  logisticServiceData,
  logisticServiceHistoryData,
  handleTabSelectionCallback,
  showSkeletonLoader,
  updateDataCallback,
  updateWithoutLoader
}: {
  logisticServiceData: IlogisticServiceDetails;
  logisticServiceHistoryData: ILogisticServiceHistory[];
  handleTabSelectionCallback: (newTabData: IlogisticServiceDetailsTab) => void;
  showSkeletonLoader: boolean;
  updateDataCallback: () => Promise<void>;
  updateWithoutLoader: () => Promise<void>;
}) => {
  const { onlyDevelopers } = useOnlyDevelopers();
  return (
    <div className={`LogisticServiceDetailsHeader ${onlyDevelopers ? 'paddingTop12' : ''}`}>
      <LogisticServiceHeaderInformationSection
        logisticServiceData={logisticServiceData}
        logisticServiceHistoryData={logisticServiceHistoryData}
        handleTabSelectionCallback={handleTabSelectionCallback}
        showSkeletonLoader={showSkeletonLoader}
        updateDataCallback={updateDataCallback}
        updateWithoutLoader={updateWithoutLoader}
      />
    </div>
  );
};

export default LogisticServiceDetailsHeader;
